/** Wrong-place pop & settle timings (piece local scale). */
export const PIECE_SETTLE_SCALE_UP_MS = 100;
export const PIECE_SETTLE_SCALE_DOWN_MS = 150;
export const PIECE_SETTLE_TOTAL_MS = PIECE_SETTLE_SCALE_UP_MS + PIECE_SETTLE_SCALE_DOWN_MS;

const STYLE_ID = "jigsaw-piece-settle-keyframes";

/**
 * Inject once: 1.0 → 1.15 (ease-out 100ms) → 1.0 (bounce ease 150ms).
 */
export function ensurePieceSettleStyle() {
    if (typeof document === "undefined") return;
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
@keyframes jigsaw-piece-settle {
  0% { transform: scale(1); }
  ${((PIECE_SETTLE_SCALE_UP_MS / PIECE_SETTLE_TOTAL_MS) * 100).toFixed(2)}% {
    transform: scale(1.15);
    animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  100% { transform: scale(1); }
}
.jigsaw-piece-settle {
  transform-origin: center center;
  animation: jigsaw-piece-settle ${PIECE_SETTLE_TOTAL_MS}ms ease-out both;
}
`;
    document.head.appendChild(style);
}
